<template>
  <div class="menu-wrapper">
    <template v-for="item in routesList" v-if="!item.hidden&&item.children">

      <router-link v-if="hasOneShowingChildren(item.children) && !item.children[0].children&&!item.alwaysShow" :to="item.path+'/'+item.children[0].path"
        :key="item.children[0].name">
        <el-menu-item :index="item.path+'/'+item.children[0].path" :class="{'submenu-title-noDropdown':!isNest}">
          <i v-if="item.children[0].meta&&item.children[0].meta.icon" class="iconfont " :class="item.children[0].meta.icon"></i>
          <span v-if="item.children[0].meta&&item.children[0].meta.title" slot="title">{{item.children[0].meta.title}}</span>
        </el-menu-item>
      </router-link>

      <el-submenu v-else :index="item.name||item.path" :key="item.name">
        <template slot="title">
          <i v-if="item.meta&&item.meta.icon" class="iconfont " :class="item.meta.icon"></i>
          <span v-if="item.meta&&item.meta.title" slot="title">{{item.meta.title}}</span>
        </template>

        <template v-for="child in item.children" v-if="!child.hidden">
          <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children&&child.children.length>0" :routes="[child]" :key="child.path"></sidebar-item>

          <router-link v-else :to="item.path+'/'+child.path" :key="child.name">
            <el-menu-item :index="item.path+'/'+child.path">
              <i v-if="child.meta&&child.meta.icon" class="iconfont " :class="child.meta.icon"></i>
              <span v-if="child.meta&&child.meta.title" slot="title">{{child.meta.title}}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>
    </template>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      routesList: [],
      typesAction: {
        1: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
        2: [12],
        3: [0, 1, 2, 3, 4, 5, 6, 7],
        4: [8, 9, 10, 11],
      },
      role: 1
    }
  },
  computed: {
    ...mapState(['user'])
  },
  watch: {
    '$route'(to, form) {
      this.checkRoute()
    }
  },
  mounted () {
    let _list = []
    this.role = Number(this.user.userInfo.role)
    this.routes.map(item => {
      if (item.meta && this.typesAction[this.role].indexOf(item.meta.id) > -1) {
        _list.push(item)
      }
    })
    this.routesList = _list
    this.checkRoute()
  },
  methods: {
    // 判断当前路由是否可以展示
    checkRoute () {
      let matched = this.$route.matched.filter(item => item.name)
      const first = matched[0]
      let _canOpen = this.routesList.filter(item => item.name == first.name)
      if (!_canOpen.length) {
        this.$router.replace({ path: '/' })
      }
    },
    hasOneShowingChildren(children) {
      const showingChildren = children.filter(item => {
        return !item.hidden
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue